var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9,0C5.63,2.87,3.52,3,0,3V14.53c0,4.6,3.2,5.8,9,9.47,5.8-3.66,9-4.86,9-9.47V3c-3.52,0-5.63-.13-9-3Zm-.55,15l-3.45-3.36,1.24-1.24,2.22,2.12,4.38-4.47,1.24,1.24-5.62,5.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.0c8935d938c6f25a06ed4f9657087f14.svg";
export { ForwardRef as ReactComponent };